export const educationData = [
    {
        id: 1,
        institution: 'Amrita Vishwa Vidyapeetham',
        course: 'B.Tech',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Shree Kalaimagal Matric HR.SEC School',
        course: 'Higher Secondary',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Shree Kalaimagal Matric HR.SEC School',
        course: 'Secondary School',
        startYear: '2012',
        endYear: '2019'
    },
]